<template>
  <a-layout-header class="header">
    <div class="brand">
      <router-link to="/">
        <img src="@/assets/logo-mark.svg" alt="" class="brand-mark">
        <span class="brand-name">夕梦</span>
        <span class="brand-sep"></span>
        <span class="brand-sub">管理后台</span>
      </router-link>
    </div>
    <div v-if="$store.state.userInfo != null" class="user">
      <a-dropdown v-model:visible="visible" :trigger="['click']" :placement="'bottomRight'">
        <div class="user-trigger" @click.prevent>
          <span class="user-avatar">{{ initial }}</span>
          <span class="user-name">{{ $store.state.userInfo.userName }}</span>
          <up-outlined v-if="visible" class="user-caret" />
          <down-outlined v-else class="user-caret" />
        </div>
        <template #overlay>
          <a-menu @click="handleMenuClick">
            <a-menu-item @click="doLogOut">退出登录</a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </a-layout-header>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue'
import { getUserInfo } from '@/api/admin-user'
import { message } from 'ant-design-vue'
import { logout } from '@/api/login'
import { loginUrl } from '@/setting'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'Navbar',
  components: {
    DownOutlined,
    UpOutlined
  },
  setup () {
    const visible = ref(false)
    const store = useStore();
    // 用用户名首字做头像，比一张所有人共用的默认头像图有信息量
    const initial = computed(() => {
      const n = store.state.userInfo && store.state.userInfo.userName
      return n ? n.trim().charAt(0).toUpperCase() : '?'
    })
    const handleMenuClick = e => {
      if (e.key === '1') {
        visible.value = false
      }
    }

    const doLogOut = e => {
      logout().then(res => {
        if (res.success) {
          // const { data } = res
          // userInfo.value = data
          store.dispatch("logout");
        } else {
          message.error(res.message)
        }
      }).catch(error => {
        message.error(error.message)
      }).finally(() => {
        location.href = loginUrl
      })
    }

    return {
      selectedKeys1: ref(['2']),
      visible,
      initial,
      handleMenuClick,
      doLogOut
    }
  }
})
</script>

<style lang="less" scoped>
@import '@/style/variables.less';

.header {
  height: @header-h;
  line-height: @header-h;
  padding: 0 20px;
  background: @bg-surface;
  border-bottom: 1px solid @border-1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 10;
}

.brand a {
  display: flex;
  align-items: center;
  gap: 10px;
  color: @text-1;
}
.brand-mark { width: 28px; height: 28px; border-radius: 8px; display: block; }
.brand-name {
  font-size: 17px;
  font-weight: 650;
  letter-spacing: .06em;
  color: @text-1;
}
.brand-sep { width: 1px; height: 14px; background: @border-1; }
.brand-sub { font-size: 13px; color: @text-3; }

.user-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px;
  height: 36px;
  border-radius: @radius-sm;
  cursor: pointer;
  transition: background .15s ease;
  &:hover { background: @bg-hover; }
}
.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: @brand-500;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  flex: none;
}
.user-name { font-size: 13px; color: @text-2; }
.user-caret { font-size: 10px; color: @text-4; }
</style>
